import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { HttpService } from '../../core/services/http.service';
import * as fromRoot from '../../store';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {
  private baseUrl = `${environment.host}ms-parameter/api/v1/parameter/`;

  filtersToCharge: any[];
  countriesList;
  currentRole: string;
  certificates: any;
  users: any;
  private translations;

  constructor(
    private httpService: HttpService,
    private store: Store<fromRoot.AuthState>,
    private translate: TranslateService
  ) {
    this.translate.get('grid').subscribe({
      next: data => (this.translations = data)
    });
  }

  fitFilters(): Observable<any> {
    this.store
      .pipe(select(fromRoot.selectSessionCurrentrole))
      .subscribe(currentRole => (this.currentRole = currentRole.code));

    return forkJoin(this.filterRequests).pipe(
      map(response => response),
      tap(filters => this.setFilters(filters))
    );
  }

  setFilters(filters) {
    if (this.currentRole === 'ROLE_1') {
      this.users = { role: filters[0].data, status: filters[1].data };
    } else {
      const edit = this.editFilter;
      this.certificates = {
        country: filters[0].data,
        status: filters[1].data,
        edit
      };
    }
  }

  get filterRequests() {
    if (this.currentRole === 'ROLE_1') {
      return [this.roles, this.userStates];
    } else {
      return [this.countries, this.oeaStates];
    }
  }

  get roles() {
    this.httpService.uri = `${this.baseUrl}role`;
    return this.httpService.execGetJson();
  }

  get userStates() {
    this.httpService.uri = `${this.baseUrl}state-user`;
    return this.httpService.execGetJson();
  }

  get countries() {
    this.httpService.uri = `${this.baseUrl}country`;
    return this.httpService.execGetJson();
  }

  get oeaStates() {
    this.httpService.uri = `${this.baseUrl}all-state-oea`;
    return this.httpService.execGetJson().pipe(
      map(data => {
        data.data.push({ shortName: 'Todos', code: 'ALL' });
        return data;
      })
    );
  }

  get editFilter() {
    const { edited, noEdit } = this.translations;
    return [
      { code: edited, shortName: 'edit' },
      { code: noEdit, shortName: 'noEdit' }
    ];
  }

  get certificatesFilters() {
    return this.certificates;
  }

  get usersFilters() {
    return this.users;
  }
}
